import { useMutation, useQuery } from '@tanstack/react-query';
import { postBulkUserInvite } from '../../../api/Terminal/UserAccount';
import type { IPostBulkUserInvitePayload } from '../../../api/Terminal/UserAccount/types';
import { getUsers, type IGetUsersServiceRes, type IPostUserInviteServicePayload, sendInvite, userQueryKeys } from '../../../api/user';
import type { QueryParamsInterface } from '../../../types/Shared';

interface IUsersHookProps {
  onSuccess?: (data: IGetUsersServiceRes) => void;
  onError?: (err: unknown) => void;
  params?: QueryParamsInterface;
}

export const useUsers = ({ onSuccess, onError, params }: IUsersHookProps) => {
  //Tanstack: version 5 query implementation
  return useQuery({
    queryKey: userQueryKeys.list(params),
    queryFn: () => getUsers({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};

interface IBulkUserInviteHookProps {
  onSuccess?: (data: unknown) => void;
  onError?: (err: unknown) => void;
}

export const useBulkUserInvite = ({ onSuccess, onError }: IBulkUserInviteHookProps) => {
  return useMutation((data: IPostBulkUserInvitePayload) => postBulkUserInvite({ data }), {
    onSuccess,
    onError,
  });
};

export const useUserInvite = ({ onSuccess, onError }: IBulkUserInviteHookProps) => {
  return useMutation((data: IPostUserInviteServicePayload) => sendInvite(data), {
    onSuccess,
    onError,
  });
};
